import ajax from './ajax'
// const BASE_URL = 'http://172.20.60.100:9192'
// export const BASE_URL = 'http://www.kamlung.net'
export const BASE_URL = 'https://www.kamlung.net:8080'
    // export const BASE_URL = 'http://172.20.60.100:9192'
    // const BASE_URL = '/api'
    // http: //172.20.60.100:9192/usedcar/upload/usedCar/1555738161111_1.jpg

// 1、获取二手车列表
export const reqCarList = (currentPage, pageSize, position) => ajax(BASE_URL + `/usedcar/usedCarInventory/getUsedCars`, { currentPage, pageSize, position }, 'POST')

// 1、查询筛选二手车列表
export const reqGetUsedCars = (currentPage, pageSize, brandId, carAttr, publishSort, carYearSort, mileageSort, priceSort, minPrice, maxPrice, position, otherBrand) => ajax(BASE_URL + `/usedcar/usedCarInventory/getUsedCars`, { currentPage, pageSize, brandId, carAttr, publishSort, carYearSort, mileageSort, priceSort, minPrice, maxPrice, position, otherBrand }, 'POST')

// 1.1、添加车型        
export const reqCarAdd = ({ title, price, priceNew, isRecommend, isFlashSale, emissionStandard, mileage, carType, location, licensDate, yearInspectDate, insureDate, maintainInfo, carLength, carWidth, carHeight, wheelbase, engine, driveType, gearBox, outputVolume, oil, describe, favouredPolicy, brandId, modelId, ids, carAttr }) => ajax(BASE_URL + '/usedcar/usedCarInventory/addUsedCar', { title, price, priceNew, isRecommend, isFlashSale, emissionStandard, mileage, carType, location, licensDate, yearInspectDate, insureDate, maintainInfo, carLength, carWidth, carHeight, wheelbase, engine, driveType, gearBox, outputVolume, oil, describe, favouredPolicy, brandId, modelId, ids, carAttr }, 'POST')

// 1.2、修改车型
export const reqCarUpd = (id, { title, price, priceNew, isRecommend, isFlashSale, emissionStandard, mileage, carType, location, licensDate, yearInspectDate, insureDate, maintainInfo, carLength, carWidth, carHeight, wheelbase, engine, driveType, gearBox, outputVolume, oil, describe, favouredPolicy, brandId, modelId, ids, carAttr }) => ajax(BASE_URL + '/usedcar/usedCarInventory/updateUsedCar', { id, title, price, priceNew, isRecommend, isFlashSale, emissionStandard, mileage, carType, location, licensDate, yearInspectDate, insureDate, maintainInfo, carLength, carWidth, carHeight, wheelbase, engine, driveType, gearBox, outputVolume, oil, describe, favouredPolicy, brandId, modelId, ids, carAttr }, 'POST')

// 1.3、查询二手车详情
export const reqCarDetail = (id) => ajax(BASE_URL + '/usedcar/usedCarInventory/getUsedCarDetail', { id }, 'POST')

// 1.4、删除二手车
export const reqDelUsedCar = (id) => ajax(BASE_URL + '/usedcar/usedCarInventory/delUsedCar', { id }, 'POST')

// 1.5、上传图片
export const reqUpload = () => ajax(BASE_URL + '/usedcar/usedCarInventory/uploadFileForCar', {}, 'POST')




// 1.5、优惠政策列表
export const reqAllFP = () => ajax(BASE_URL + '/usedcar/usedCarInventory/getAllFavouredPolicy', {}, 'POST')

// 1.6、优惠政策添加
export const reqAllFPAdd = (policyName) => ajax(BASE_URL + '/usedcar/usedCarInventory/addFavouredPolicy', { policyName }, 'POST')

// 2、获取品牌列表
export const reqCarBrandList = () => ajax(BASE_URL + '/usedcar/carModel/getAllCarBrand', {}, 'POST')

// 2.1、添加品牌
export const reqCarBrandAdd = ({ brandName, sortNo, isAble, imgId }, imageType) => ajax(BASE_URL + '/usedcar/carModel/addCarBrand', { brandName, sortNo, isAble, imgId, imageType }, 'POST')

// 2.2、修改品牌
export const reqCarBrandUpd = ({ id, brandName, sortNo, isAble, imgId }) => ajax(BASE_URL + '/usedcar/carModel/updateCarBrand', { id, brandName, sortNo, isAble, imgId }, 'POST')

// 2.3、删除品牌
export const reqDeleteCarBrand = (id) => ajax(BASE_URL + '/usedcar/carModel/deleteCarBrand', { id }, 'POST')


// 3、获取车型列表
export const reqCarModelList = (brandId) => ajax(BASE_URL + '/usedcar/carModel/getAllCarModel', { brandId }, 'POST')

// 3.1、添加车型
export const reqCarModelAdd = (brandId, { modelName, sortNo, isAble }) => ajax(BASE_URL + '/usedcar/carModel/addCarModel', { brandId, modelName, sortNo, isAble }, 'POST')

// 3.2、修改车型
export const reqCarModelUpd = ({ brandId, id, modelName, sortNo, isAble }) => ajax(BASE_URL + '/usedcar/carModel/updateCarModel', { brandId, id, modelName, sortNo, isAble }, 'POST')

// 3.3、删除品牌
export const reqDeleteCarModel = (id) => ajax(BASE_URL + '/usedcar/carModel/deleteCarModel', { id }, 'POST')


// 4、获取评估记录
export const reqCarAssess = (currentPage, pageSize) => ajax(BASE_URL + '/usedcar/carAssess/getCarAssess', { currentPage, pageSize }, 'POST')

// 4.1、添加评估单
export const reqAddCarAssess = ({ carBrand, carModel, licensDate, licensMonth, licensLocation, mileage, cusName, phoneNo, position }) => ajax(BASE_URL + '/usedcar/carAssess/addCarAssess', { carBrand, carModel, licensDate, licensMonth, licensLocation, mileage, cusName, phoneNo, position }, 'POST')


// 5、查询卖车信息列表
export const reqCarSales = (currentPage, pageSize) => ajax(BASE_URL + '/usedcar/carAssess/getCarSales', { currentPage, pageSize }, 'POST')

// 5.1、添加卖车信息
export const reqAddSaleUser = ({ phoneNo, location, position }) => ajax(BASE_URL + '/usedcar/carAssess/addSaleUser', { phoneNo, location, position }, 'POST')


// 6、查询活动列表
export const reqActivity = (currentPage, pageSize, position) => ajax(BASE_URL + '/usedcar/activity/getActivity', { currentPage, pageSize, position }, 'POST')

// 6.1、添加活动
export const reqActivityAdd = ({ title, activityType, content }) => ajax(BASE_URL + '/usedcar/activity/addActivity', { title, activityType, content }, 'POST')

// 6.3、活动详情
export const reqGetActivityDetail = (id) => ajax(BASE_URL + '/usedcar/activity/getActivityDetail', { id }, 'POST')


// 7、查询二手车置换列表
export const reqCarForChange = (currentPage, pageSize) => ajax(BASE_URL + '/usedcar/usedCarInventory/getCarForChange', { currentPage, pageSize }, 'POST')

// 7.1、修改处理置换车辆信息
export const reqUpdateCarForChange = (id, status) => ajax(BASE_URL + '/usedcar/usedCarInventory/updateCarForChange', { id, status }, 'POST')

// 7.2、添加处理置换车辆信息
export const reqAddCarForChange = ({ oldCarBrand, firstRegister, mileage, city, newCarBrand, phoneNo, service, position }) => ajax(BASE_URL + '/usedcar/usedCarInventory/addCarForChange', { oldCarBrand, firstRegister, mileage, city, newCarBrand, phoneNo, service, position }, 'POST')

// 8、banner查询
export const reqBanners = (currentPage, pageSize, activityType, position) => ajax(BASE_URL + '/usedcar/activity/getBanners', { currentPage, pageSize, activityType, position }, 'POST')


// WEBPACK FOOTER //
// ./src/api/index.js